/**
 * Regalo «proteína Applied → shaker Applied» (e-Growth, 19-10-2026).
 *
 * Si en el carrito hay ISO-XP, Critical Whey o Beef-XP (cualquier variante),
 * añade 1 x Shaker Applied Nutrition Azul 800 ml con la propiedad
 * _regalo = "shaker" (el carrito la pinta como «Regalo»). Si se quitan las
 * proteínas, lo quita. Las creatinas NO disparan el regalo.
 *
 * El precio a 0 lo pone el descuento automático BXGY de Shopify
 * «Applied · Shaker de regalo con proteína · 19-27 oct», no este JS.
 * Guarda de cobro: tras añadir el regalo se mira el precio final de la línea.
 * Si no es 0 (descuento sin activar, borrado o fuera de fecha), se retira y no
 * se reintenta durante 10 minutos. Fuera de la ventana de fechas de la config
 * no hace nada.
 *
 * Modo prueba (solo en temas NO publicados): ?regaloshaker=test desactiva la
 * guarda y la ventana de fechas. ?regaloshaker=off lo apaga.
 */
(function () {
  'use strict';

  var PROP = '_regalo';
  var PROP_VALUE = 'shaker';
  var BLOCK_KEY = 'regaloshaker_blocked_until';
  var TEST_KEY = 'regaloshaker_test';

  var configEl = document.getElementById('regalo-shaker-config');
  if (!configEl) return;
  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!config || !config.giftVariantId || !Array.isArray(config.triggerProductIds)) return;

  var GIFT_ID = Number(config.giftVariantId);
  var TRIGGERS = {};
  config.triggerProductIds.forEach(function (id) { TRIGGERS[Number(id)] = true; });
  var START = Date.parse(config.startsAt || '') || 0;
  var END = Date.parse(config.endsAt || '') || Infinity;

  var storage = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* sin storage */ } },
    del: function (k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* sin storage */ } },
  };

  var isLiveTheme = !(window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main');
  (function readTestFlag() {
    var m = /[?&]regaloshaker=(test|off)\b/.exec(window.location.search);
    if (!m) return;
    if (m[1] === 'test' && !isLiveTheme) { storage.set(TEST_KEY, '1'); storage.del(BLOCK_KEY); }
    if (m[1] === 'off') { storage.del(TEST_KEY); }
  })();
  var testMode = !isLiveTheme && storage.get(TEST_KEY) === '1';

  var routes = function () {
    var r = (window.FoxTheme && window.FoxTheme.routes) || {};
    return {
      add: (r.cart_add_url || '/cart/add') + '.js',
      change: (r.cart_change_url || '/cart/change') + '.js',
      cart: (r.cart_url || '/cart') + '.js',
      root: r.root_url || '/',
    };
  };

  var postJSON = function (url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (t) { throw new Error(url + ' ' + res.status + ' ' + t); });
      }
      return res.json();
    });
  };

  var getCart = function () {
    return fetch(routes().cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  };

  var isGiftLine = function (item) {
    return Number(item.variant_id) === GIFT_ID && item.properties && item.properties[PROP] === PROP_VALUE;
  };

  var hasTrigger = function (cart) {
    return cart.items.some(function (item) {
      return TRIGGERS[Number(item.product_id)] && !(item.properties && item.properties[PROP]);
    });
  };

  var giftLines = function (cart) {
    return cart.items.filter(isGiftLine);
  };

  // Precio final de la línea regalo (céntimos). 0 = el descuento la deja gratis.
  var lineFinalPrice = function (item) {
    if (typeof item.final_line_price === 'number') return item.final_line_price;
    return item.line_price || 0;
  };

  var removeGift = function (item) {
    return postJSON(routes().change, { id: item.key, quantity: 0 });
  };

  var busy = false;
  var dirty = false;

  // Repinta drawer y /cart con el mecanismo del propio tema (pubsub cartUpdate).
  var refreshUI = function () {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    var unique = sections.filter(function (s, i) { return s && sections.indexOf(s) === i; });
    var sectionsReq = unique.length
      ? fetch(routes().root + '?sections=' + encodeURIComponent(unique.join(','))).then(function (r) { return r.ok ? r.json() : null; })
      : Promise.resolve(null);
    return Promise.all([getCart(), sectionsReq]).then(function (res) {
      var cart = res[0];
      if (res[1]) cart.sections = res[1];
      if (window.FoxTheme && window.FoxTheme.pubsub) {
        window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      }
      if (!cart.sections) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    });
  };

  var reconcile = function () {
    if (busy) { dirty = true; return Promise.resolve(); }
    busy = true;
    var changed = false;

    return getCart()
      .then(function (cart) {
        var gifts = giftLines(cart);
        var now = Date.now();
        var inWindow = testMode || (now >= START && now <= END);
        var blocked = !testMode && Number(storage.get(BLOCK_KEY) || 0) > now;
        var wanted = hasTrigger(cart) && inWindow && !blocked;

        // Sobra el regalo: no hay proteína, fuera de fechas o bloqueado. Quitar todas sus líneas.
        if (!wanted && gifts.length) {
          changed = true;
          return gifts.reduce(function (p, g) { return p.then(function () { return removeGift(g); }); }, Promise.resolve());
        }

        // Duplicados o cantidad > 1: dejar una sola unidad.
        if (wanted && (gifts.length > 1 || (gifts[0] && gifts[0].quantity !== 1))) {
          changed = true;
          var chain = Promise.resolve();
          gifts.slice(1).forEach(function (g) { chain = chain.then(function () { return removeGift(g); }); });
          return chain.then(function () { return postJSON(routes().change, { id: gifts[0].key, quantity: 1 }); });
        }

        // Falta el regalo: añadirlo y comprobar que sale a 0.
        if (wanted && !gifts.length) {
          changed = true;
          var props = {};
          props[PROP] = PROP_VALUE;
          return postJSON(routes().add, { items: [{ id: GIFT_ID, quantity: 1, properties: props }] })
            .then(getCart)
            .then(function (after) {
              if (testMode) return;
              var added = giftLines(after)[0];
              if (added && lineFinalPrice(added) > 0) {
                storage.set(BLOCK_KEY, String(Date.now() + 10 * 60 * 1000));
                return removeGift(added);
              }
            });
        }

        // Regalo presente fuera de modo prueba: si dejó de salir gratis, retirarlo.
        if (wanted && gifts.length === 1 && !testMode && lineFinalPrice(gifts[0]) > 0) {
          changed = true;
          storage.set(BLOCK_KEY, String(Date.now() + 10 * 60 * 1000));
          return removeGift(gifts[0]);
        }
      })
      .catch(function (err) {
        console.warn('[regalo-shaker]', err && err.message ? err.message : err);
      })
      .then(function () {
        busy = false;
        if (changed) return refreshUI();
      })
      .then(function () {
        if (dirty) { dirty = false; return reconcile(); }
      });
  };

  var timer;
  var schedule = function () {
    clearTimeout(timer);
    timer = setTimeout(function () { if (!busy) reconcile(); else dirty = true; }, 250);
  };

  document.addEventListener('cart:updated', schedule);
  if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.subscribe) {
    window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, schedule);
  }
  schedule();
})();
